export const getFirstNameFromUser = (user = {}) => {
  const displayName = String(user?.displayName || "").trim();
  const email = String(user?.email || "").trim();

  if (displayName) {
    return displayName.split(" ")[0];
  }

  const localPart = email.split("@")[0] || "";
  const cleaned = localPart.split(/[._-]+/).filter(Boolean)[0] || "";

  if (!cleaned) return "";

  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1).toLowerCase();
};

export const getFormattedDateTime = (date = new Date(), locale = "en-GB") => {
  const formatted = date.toLocaleString(locale, {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return formatted.replace(" at ", " • ");
};

export const getGreetingByTime = (date = new Date(), name = "") => {
  const hour = date.getHours();

  if (hour < 12) {
    return `Good morning${name ? `, ${name}!` : ""}`;
  }

  if (hour < 18) {
    return `Good afternoon${name ? `, ${name}!` : ""}`;
  }

  return `Good evening${name ? `, ${name}!` : ""}`;
};

export const getDepartmentGreetingData = (
  user = {},
  date = new Date(),
  locale = "en-GB",
) => {
  const firstName = getFirstNameFromUser(user);
  const greeting = getGreetingByTime(date, firstName);
  const formattedDateTime = getFormattedDateTime(date, locale);

  return {
    firstName,
    greeting,
    formattedDateTime,
  };
};

export const formatLondonDateTimeFromTimestamp = (
  timestamp,
  locale = "en-GB",
) => {
  return new Intl.DateTimeFormat(locale, {
    timeZone: "Europe/London",
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  })
    .format(new Date(timestamp))
    .replace(" at ", " • ");
};

export const getLondonHourFromTimestamp = (timestamp) => {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London",
    hour: "numeric",
    hour12: false,
  }).formatToParts(new Date(timestamp));

  return Number(parts.find((part) => part.type === "hour")?.value || 0);
};

export const getGreetingFromTimestamp = (timestamp, name = "") => {
  const hour = getLondonHourFromTimestamp(timestamp);

  if (hour < 12) return `Good morning${name ? `, ${name}!` : ""}`;
  if (hour < 18) return `Good afternoon${name ? `, ${name}!` : ""}`;
  return `Good evening${name ? `, ${name}!` : ""}`;
};

export const getDepartmentGreetingDataFromTimestamp = (
  timestamp,
  user = {},
  locale = "en-GB",
) => {
  const firstName = getFirstNameFromUser(user);
  const greeting = getGreetingFromTimestamp(timestamp, firstName);
  const formattedDateTime = formatLondonDateTimeFromTimestamp(
    timestamp,
    locale,
  );

  return {
    firstName,
    greeting,
    formattedDateTime,
  };
};
